import { ACTION_TYPES } from '../constants';
import { createReducer } from '@reduxjs/toolkit';

// =============================================
// Reducer at question level of the data branch:
// =============================================
export const faqsDataQuestion = createReducer({}, (builder) => {
  builder.addCase(ACTION_TYPES.UPDATE_QST_SUCCESSFUL, (state, action) => {
    return action.question;
  });
});

// =============================================
// Reducer at category level of the data branch:
// =============================================

export const faqsDataCategory = createReducer({}, (builder) => {
  builder
    .addCase(
      ACTION_TYPES.UPDATE_CTG_SUCCESSFUL,
      (state, action) => action.category,
    )
    .addCase(ACTION_TYPES.ADD_QST_SUCCESSFUL, (state, action) => {
      state.questions = [...(state?.questions ?? []), action.question];
      return state;
    })
    .addCase(ACTION_TYPES.DELETE_QST_SUCCESSFUL, (state, action) => {
      state.questions = state.questions.filter(
        (qst) => qst.faq_id !== action.question.faq_id,
      );
      return state;
    })
    .addCase(ACTION_TYPES.UPDATE_QST_SUCCESSFUL, (state, action) => {
      const questionIndex = state.questions.findIndex(
        (qst) => qst.faq_id === action.question.faq_id,
      );

      if (questionIndex !== -1) {
        state.questions[questionIndex] = action.question;
      }

      return state;
    });
});

// =============================================
// Reducer at the root level of the data branch:
// =============================================
// eslint-disable-next-line import/no-default-export -- FIXME: Convert to a named export https://github.com/wegotpop/popsss/wiki/Imports#default-exports
export default createReducer([], (builder) => {
  // root level operations:
  builder
    .addCase(
      ACTION_TYPES.LOAD_FAQS_SUCCESSFUL,
      (state, action) => action.faqsData,
    )
    .addCase(ACTION_TYPES.ADD_CTG_SUCCESSFUL, (state, action) => {
      state.push(action.category);
      return state;
    })

    .addCase(ACTION_TYPES.DELETE_CTG_SUCCESSFUL, (state, action) =>
      state.filter((ctg) => ctg.group_id !== action.category.group_id),
    )

    // delegated to category level operations:
    .addCase(ACTION_TYPES.UPDATE_CTG_SUCCESSFUL, updateQuestion)
    .addCase(ACTION_TYPES.ADD_QST_SUCCESSFUL, updateQuestion)
    .addCase(ACTION_TYPES.DELETE_QST_SUCCESSFUL, updateQuestion)
    .addCase(ACTION_TYPES.UPDATE_QST_SUCCESSFUL, updateQuestion);
});

function updateQuestion(state, action) {
  let indexCtg;
  indexCtg = state.findIndex(
    (ctg) => ctg.group_id === action.category.group_id,
  );
  if (indexCtg != -1) {
    state[indexCtg] = faqsDataCategory(state[indexCtg], action);
  }
  return state;
}
